import { COVERGO_SAAS_DEV, COVERGO_CA_UAT, COVERGO_PBC_UAT, COVERGO_ASIA_QA } from "../consts.js"

export const pbc_dev = {
	"pbc-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "pbc_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-pbc-dev"
		}
	}
}

export const pbc_uat = {
	// Deployed PBC UAT enterprise host (Istio: studio.uat.pbc.canada.covergo.net)
	"studio.uat.pbc.canada.covergo.net": {
		appConfig: {
			tenantId: "pbc_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_PBC_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-pbc-uat"
		}
	},
	// Legacy SaaS host (kept for backward-compat; points at old CA UAT backend)
	"pbc-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "pbc_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-pbc-uat"
		}
	},
}

export const pbc_qa = {
	"pbc-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "pbc_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-pbc-qa"
		}
	},
}

export const pbc_migration = {
	// PBC Migration tenant on the PBC UAT enterprise cluster (reuses the PBC UAT gateways, own bucket)
	"studio-migration.uat.pbc.canada.covergo.net": {
		appConfig: {
			tenantId: "pbc_migration",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_PBC_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-pbc-migration-uat"
		}
	},
}

